import { useForm } from "react-hook-form";
import { GenericComponent } from "../../components/GenericComponent";
import { Roles } from "../../models/Roles";
import { InputComponent } from "../../components/InputComponent";
import { RolService } from "../../service/RolService";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";
import { Toolbar } from "primereact/toolbar";
import { MenuRol } from "./MenuRol";
import { Generico } from "../../components/Generico";
import { MenuFuncion } from "./MenuFuncion";
import { AsignarRol } from "./AsignarRol";
import { useToken } from "../../components/useToken";

export const Rol = () => {

    const generic = new GenericComponent();
    const omodel = new Roles();
    const model = omodel.model;
    const [permss, setPermss] = useState(null);
    const defaultValues = generic.default(model);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const toast = useRef(null);
    const [roles, setRoles] = useState(null);
    const { table, setLoading, setTotalRecords, lazyParams, inText, inDrop } = InputComponent({ registers: roles, omodel, generic, errors, control, permss, id: getValues('id') });
    const rolService = new RolService();
    const [dialogRol, setDialogRol] = useState(false);
    const [rol, setRol] = useState(null);
    const { getRol } = useToken();
    const [dialogMenu, setDialogMenu] = useState(false);
    const [dialogFuncion, setDialogFuncion] = useState(false);
    const [dialogOtroRol, setDialogOtroRol] = useState(false);
    const [opcion, setOpcion] = useState(null);
    const { accionesTbl } = Generico();

    useEffect(() => {
        loadLazyRol();
    }, [lazyParams]);

    const confirmDelete = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar el rol?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminarRol()
        });
    }

    const eliminarRol = () => {
        rolService.eliminar(rol?.id).then(res => {
            loadLazyRol();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const openNew = () => {
        reset(defaultValues);
        setDialogRol(true);
        setRol(null);
    }

    const loadLazyRol = () => {
        setLoading(true);

        let _lazyParams = lazyParams;
        delete _lazyParams.rtipo;
        if (permss == null) {
            _lazyParams.rtipo = true;
            _lazyParams.rol = getRol()?.id;
        }
        rolService.getRoles({ lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRoles(res.data.registros);
            setLoading(false);
            if (res.data.perss !== undefined) {
                setPermss(res.data.perss);
                setOpcion(res.data.opcion);
            }
        });
    }

    const onSubmit = (data) => {
        if (getValues('id') == null) {
            rolService.newRol(data).then(res => {
                setDialogRol(false);
                loadLazyRol();
                generic.funcSuccess(res, toast);
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
        else {
            rolService.editRol(data).then(res => {
                setDialogRol(false);
                loadLazyRol();
                generic.funcSuccess(res, toast);
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
    }

    const editRol = () => {
        rolService.consultarRol(rol?.id).then(res => {
            const lista = { estado: generic.estados, registros: generic.sino, aprobar: generic.sino, mostrar_empresas: generic.sino, multiempresa: generic.sino };
            let _rol = res.data;
            Object.keys(lista).forEach(function (key) {
                if (_rol[key] != null) {
                    lista[key].forEach(element => {
                        if (element.cat_id === _rol[key]) {
                            _rol[key] = element;
                        }
                    });
                }
            });
            reset(generic.renewValues(_rol, model));
            setDialogRol(true);
        });
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar)
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editRol() } });
        if (permss?.actualizar)
            items.push({ label: 'Asignar menús', icon: 'pi pi-bars', command: () => { setDialogMenu(true) } });
        if (permss?.eliminar)
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });
        if (permss?.actualizar)
            items.push({ label: 'Asignar funcionalidad por menú', icon: 'pi pi-facebook', command: () => { setDialogFuncion(true) } });
        if (permss?.actualizar && siOpcion('roles-asignar-rol'))
            items.push({ label: 'Asignar otros roles', icon: 'pi pi-id-card', command: () => { setDialogOtroRol(true) } });

        return [{ label: 'Opciones', items: items }];
    }

    const siEdicion = (opcion = {}) => {
        const res = opcion;
        res.readOnly = rol?.habilitado;
        return res;
    }

    const siOpcion = (strOpcion) => {
        return permss?.actualizar && (opcion === 'PRELAFIT' || opcion.includes(strOpcion));
    }

    return (
        <>
            <ConfirmDialog />
            <Toast ref={toast} />
            <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                <Toolbar className="mb-4" start={generic.leftToolbarTemplate(openNew, '', permss)}></Toolbar>
                {table({ action01: accionesTbl, reg: setRol, items: itemsMenu() })}
            </Card>

            <Dialog visible={dialogRol} header={getValues('id') == null ? "Nuevo rol" : "Editar rol"} modal className="p-fluid modal-ssize"
                onHide={e => setDialogRol(false)} style={{ maxWidth: '600px' }} >
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid">
                        {inText('nombre', siEdicion(), 6)}
                        {inText('nemonico', siEdicion({ obl: 'no' }), 6)}
                        {inText('descripcion', { obl: 'no' }, 6)}
                        {inDrop('estado', generic.estados, { lab: 'nombre' }, 6)}
                        {inDrop('registros', generic.sino, { lab: 'nombre' }, 6)}
                        {inDrop('aprobar', generic.sino, { lab: 'nombre' }, 6)}
                        {inDrop('mostrar_empresas', generic.sino, { lab: 'nombre' }, 6)}
                        {inDrop('multiempresa', generic.sino, { lab: 'nombre' }, 6)}
                    </div>
                    {generic.buttonsForms(setDialogRol)}
                </form>
            </Dialog>

            <Dialog visible={dialogMenu} header={"Asignar menús al rol: " + rol?.nombre} modal className="p-fluid modal-ssize" onHide={e => setDialogMenu(false)} style={{ maxWidth: '1000px' }}>
                <MenuRol id={rol?.id} toast={toast} permss={permss} />
            </Dialog>

            <Dialog visible={dialogFuncion} header={"Asignar menú-funcionalidad: " + rol?.nombre} modal className="p-fluid modal-ssize" onHide={e => setDialogFuncion(false)}
                style={{ maxWidth: '900px' }}>
                <MenuFuncion rol={rol?.id} toast={toast} generic={generic} permss={permss} />
            </Dialog>

            <Dialog visible={dialogOtroRol} header={"Asignar otros roles: " + rol?.nombre} modal className="p-fluid modal-ssize" onHide={e => setDialogOtroRol(false)}
                style={{ maxWidth: '900px' }}>
                <AsignarRol id={rol?.id} toast={toast} generic={generic} permss={permss} />
            </Dialog>
        </>
    )
}
